import { BASE_URL, post } from 'utils/sdk';

export const createStripeAccount = ({
  nickname,
  country,
}: {
  nickname: string;
  country: string;
}) => {
  return post<{ url: string }>(`${BASE_URL}services/stripe/create-v2/`, {
    nickname,
    country,
  });
};
